/**
 * **A drawn document's page** (Stream C, Documents.dc.html): what each document engine hands the
 * print — a title and its line, an optional big figure, blocks of rows in the drawing's own grid,
 * the signature lines and the footer. A figure is cents; words are words; a figure the engine was
 * not handed is NO DATA, never a sample.
 */
export const NO_DATA = 'NO DATA';

/** A cell: words, or a figure in cents. */
export type PaperCell = string | number;

export interface PaperBlock {
  /** The block's head as drawn; '' for a block with none. */
  head: string;
  /** The drawing's grid columns for the block, as drawn. */
  cols: string;
  rows: PaperCell[][];
  /** A sentence the reader must not miss — a disagreement, printed in the one red. */
  gap?: string;
}

/** The sheet a page prints on (Paper.dc.html's sizes): a card, a badge or a tag beside the letter. */
export type PaperSize = 'letter' | 'half' | 'card' | 'card-landscape' | 'badge' | 'tag' | 'poster';

export interface PaperPage {
  title: string;
  sub: string;
  /** The page's own sheet, when it is not the document's (A02's tag beside its card). */
  size?: PaperSize;
  /** The id CIDER reads back from the QR, printed with it (`BAG 0412`). */
  qr?: string;
  /** The big line under the masthead (a figure in cents, or words) and the sentence under it. */
  big?: PaperCell;
  bigSub?: string;
  blocks: PaperBlock[];
  /** The signature lines at the foot, two to a row. */
  sign?: string[];
  foot: string;
}
